import v3ApiClient from "./client";

const AUDIT_BASE_PATH = "/v3/audit";

const cleanParams = (params = {}) => {
    const cleaned = {};

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") {
            return;
        }
        if (Array.isArray(value)) {
            if (value.length > 0) {
                cleaned[key] = value.join(",");
            }
            return;
        }
        cleaned[key] = value;
    });

    return cleaned;
};

const getData = async (promise) => {
    const response = await promise;
    return response.data;
};

const buildAuditEventListParams = (params = {}) =>
    cleanParams({
        page: params.page,
        page_size: params.page_size,
        event_type: params.event_type,
        occurred_from: params.occurred_from,
        occurred_to: params.occurred_to,
        severity: params.severity,
        outcome: params.outcome,
        risk_level: params.risk_level,
        actor_user_identifier: params.actor_user_identifier,
        actor_ip: params.actor_ip,
    });

export const auditApi = {
    getAuditEvents: (params = {}) => getData(v3ApiClient.get(`${AUDIT_BASE_PATH}/events`, { params: buildAuditEventListParams(params) })),
    getAuditEventDetail: (id) => getData(v3ApiClient.get(`${AUDIT_BASE_PATH}/events/${encodeURIComponent(id)}`)),
};

export default auditApi;
